<main class="flex justify-content-center wrapper-content mt-3  flex-column">
  <a (click)="volver()" class="text-blue-general inline-flex align-items-center no-underline cursor-pointer">
    <i class="pi pi-arrow-left"></i>
    <span class="ml-2">{{translations.volver}}</span>
  </a>
  <header class="lg:w-full w-11 mx-auto ">
    <h1 class="header-title mb-0 font-size-title font-weight-regular">{{ translations?.header }}</h1>
    <h2 class="subheader-title mt-1 font-size-title font-weight-regular">
      {{ translations?.subHeader }}
      <span class="font-bold"> {{ descripcionTramite() }}</span>
    </h2>
  </header>
  <div class="flex w-full lg:gap-5 gap-3 lg:justify-content-between justify-content-center
      lg:flex-row flex-column mx-auto">
    <article class="f-30 section-left mx-auto">
      @if (detalleTramite){
        <form class="grid font-principal text-lg content-form mb-5">
          <div class="col-12   border-none  border-bottom-1 border-gray-300	">
            <label class="app-text-gray line-text-label ">{{ translations.nombre }}</label>
            <p class="color-form-label mb-0 line-text-value mt-2">{{detalleTramite.nombreCompleto}}</p>
          </div>
          <div class="col-12   border-none  border-bottom-1 border-gray-300">
            <label class="app-text-gray line-text-label ">{{ translations.tramite }}</label>
            <p class="color-form-label mb-0 line-text-value mt-2">{{detalleTramite.tramiteDescripcion}}</p>
          </div>
          <div class="col-12 border-none  border-bottom-1 border-gray-300">
            <label class="app-text-gray line-text-label ">{{ translations.identificacion }}</label>
            <p class="color-form-label mb-0 line-text-value mt-2">{{detalleTramite.identificacion}}</p>
          </div>
          <div class="col-12 border-none  border-bottom-1 border-gray-300">
            <label class="app-text-gray line-text-label ">{{ translations.telefono }}</label>
            <p class="color-form-label mb-0 line-text-value mt-2">{{detalleTramite.telefono}}</p>
          </div>
          <div class="col-12 border-none  pb-4">
            <label class="app-text-gray line-text-label ">{{ translations.correo }}</label>
            <p class="color-form-label mb-0 line-text-value mt-2">{{detalleTramite.correo}}</p>
          </div>
        <!--  <div class="col-12 sm:col-6 flex md:block justify-content-center">
            <button class="btn" pButton type="button">
              <span>{{ translations.radicarTramite }}</span>
            </button>
          </div>-->
          <div class="col-12  mt-4 flex  justify-content-center" >
            <button class="btn flex align-items-center" pButton  type="button"
              [disabled]="!url"      (click)="iniciarPago()">
              <span>{{translations.pagar}}</span>
              <svg-loader [name]="'ico-normal-tramitfly-white'" />
            </button>
          </div>
        </form>
      } @else {

      }

    </article>
    <section class="f-70 section-right sm:pl-3 mx-auto sm:w-11 w-full" style="height:465px;">
      @if (url) {
        <iframe *ngIf="!isMobile else movil" class="w-full h-full"
                [src]="url | safeResource : 'resourceUrl'"></iframe>
      } @else {
        <p-skeleton height="100%"></p-skeleton>
      }

    </section>
  </div>
</main>


<ng-template #movil>
<div class="w-full h-20rem flex justify-content-center align-items-center bg-blue-100">
  <a  target="_blank" [href]="url | safeResource : 'resourceUrl'" class="btn px-3 py-2  no-underline">
    <i class="pi pi-download"></i>
    <span class="px-2">{{translations.descargar}}</span>
  </a>
</div>
</ng-template>

@if (pseTransaction && pseTransaction.ticket) {
  <app-datos-pago-pse [(visible)]="visibleDatosPago" (nameBank)="nombreBanco = $event"
                      (response)="generarLinkPago($event)"
                      [ticket]="pseTransaction.ticket"/>
}

